(() => {
  if (window.polewardProductDisclosureMotion) return;
  window.polewardProductDisclosureMotion = true;

  const selector = '.product-editorial details.product-editorial__disclosure, .product-editorial .product__accordion > details, .product-editorial details.poleward-restock__details';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();

  const clear = (details, state) => {
    state.animation?.cancel();
    details.style.height = state.height;
    details.style.overflow = state.overflow;
    details.style.boxSizing = state.boxSizing;
    states.delete(details);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    const details = summary?.parentElement;
    if (event.defaultPrevented || !details?.matches(selector) || summary !== details.firstElementChild) return;

    event.preventDefault();
    const previous = states.get(details);
    const targetOpen = !(previous?.targetOpen ?? details.open);
    const from = details.getBoundingClientRect().height;
    const original = previous || {
      height: details.style.height,
      overflow: details.style.overflow,
      boxSizing: details.style.boxSizing,
    };
    if (previous) clear(details, previous);
    summary.setAttribute('aria-expanded', String(targetOpen));

    if (reducedMotion.matches || event.detail === 0 || !details.animate) {
      details.open = targetOpen;
      return;
    }

    details.open = true;
    details.style.boxSizing = 'border-box';
    const style = getComputedStyle(details);
    const collapsed = summary.getBoundingClientRect().height
      + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
      + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    const to = targetOpen ? details.getBoundingClientRect().height : collapsed;
    details.style.height = `${from}px`;
    details.style.overflow = 'hidden';
    const state = { ...original, targetOpen };
    states.set(details, state);
    state.animation = details.animate({ height: [`${from}px`, `${to}px`] }, {
      duration: 220,
      easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
    });
    state.animation.onfinish = () => {
      if (states.get(details) !== state) return;
      details.open = targetOpen;
      clear(details, state);
    };
  });

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.(selector)) return;
    let state = states.get(details);
    if (state && !details.open) {
      clear(details, state);
      state = undefined;
    }
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(state?.targetOpen ?? details.open));
  }, true);
})();
